export const PageShell: React.FC = ({ children, ...rest }) => {
  return (
    <div className="page-shell" {...rest}>
      {children}
    </div>
  )
}
